// import DebuggerService from "Services/DebuggerService";
import KeyboardFocusService from "Services/KeyboardFocusService";
import "../components";

export class App {
  constructor() {
    KeyboardFocusService.init();
  }
}
